import React from "react"
import ReactDOM from "react-dom"
// import registerServiceWorker from './registerServiceWorker';
import CssBaseline from "@material-ui/core/CssBaseline"
import { MuiThemeProvider } from "@material-ui/core/styles"
import App from "./components/App/App"
// import theme from "./themes/main"
import crewMamaTheme from "./themes/crewmamaTheme"
import { Provider } from "react-redux"
import store from "./store"
import { BrowserRouter } from "react-router-dom"

import "./styles/base.css"

const appleTouchIcon = document.getElementById("apple-touch-icon")
const favicon32 = document.getElementById("favicon32")
const favicon16 = document.getElementById("favicon16")
const manifest = document.getElementById("manifest")

// if (window.location.host.indexOf("adesk") === -1) {
appleTouchIcon.href = "crewmama-favicons/apple-touch-icon.png"
favicon32.href = "crewmama-favicons/favicon-32x32.png"
favicon16.href = "crewmama-favicons/favicon-16x16.png"
manifest.href = "crewmama-favicons/site.webmanifest"
// } else {
//   appleTouchIcon.href = "apple-touch-icon.png"
//   favicon32.href = "favicon-32x32.png"
//   favicon16.href = "favicon-16x16.png"
//   manifest.href = "site.webmanifest"
// }

const Application = (
  <Provider store={store}>
    <BrowserRouter>
      <MuiThemeProvider
        theme={
          // window.location.host.indexOf("adesk") === -1 ? crewMamaTheme : theme
          crewMamaTheme
        }
      >
        <CssBaseline />
        <App />
      </MuiThemeProvider>
    </BrowserRouter>
  </Provider>
)

ReactDOM.render(Application, document.getElementById("root"))
